import { render, staticRenderFns } from "./pagination-list.vue?vue&type=template&id=e666919e"
import script from "./pagination-list.vue?vue&type=script&lang=js"
export * from "./pagination-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports